export default __webpack_public_path__ + "static/media/gt.6036a62c.svg";